/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Inject, inject } from '@angular/core';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { LoaderIndicatorDirective, LoaderService, NotificationService } from '@t-llevo/common-ui';
import { UserService } from 'admin-drivers/src/app/api/services/user.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { ChangePasswordRequest } from 'admin-drivers/src/app/api/models/requests/ChangePasswordRequest';
import { User } from 'admin-drivers/src/app/common/models/User';

@Component({
  selector: 't-llevo-client-change-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    DialogHeaderComponent,
    LoaderIndicatorDirective
  ],
  templateUrl: './client-change-password.component.html',
  providers: [
    LoaderService,
    UserService
  ],
  styles: `
    @import '../../../utils/styles/baseDialog.scss';
    @import '../../../utils/styles/formGroup.scss';
  `
})
export class ClientChangePasswordComponent {
  private userSrv = inject(UserService);
  private notifSrv = inject(NotificationService)
  private loaderSrv = inject(LoaderService)

  protected hidePassword: boolean = true;
  loading = toSignal(this.loaderSrv.loaderState$)

  frm = this._fb.group({
    newPassword: [
      '',
      [Validators.required, Validators.minLength(6), Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])/)]
    ],
    confirmPassword: [
      '',
      [Validators.required, Validators.minLength(6), Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])/)],
    ],
  });

  constructor(
    private _fb: NonNullableFormBuilder,
    public dialogRef: MatDialogRef<ClientChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User
  ) {}

  get newPassword() {
    return this.frm.controls['newPassword'];
  }

  get confirmPassword() {
    return this.frm.controls['confirmPassword'];
  }

  protected matchPasswords() {
    const errors = this.confirmPassword.errors;
    if (this.newPassword.value === this.confirmPassword.value) {
      if (errors && errors['PasswordNoMatch']) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { PasswordNoMatch, ...rest } = errors;
        Object.keys(rest).length > 0
        ? this.confirmPassword.setErrors(rest)
        : this.confirmPassword.setErrors(null)
      }
    } else {
      if (errors) {
        this.confirmPassword.setErrors({ ...errors, PasswordNoMatch: true });
      } else {
        this.confirmPassword.setErrors({ PasswordNoMatch: true });
      }
    }
  }

  onSubmit() {
    this.loaderSrv.show()
    this.userSrv.changePassword(this.getFormData())
    .pipe(
      finalize(() => this.loaderSrv.hide())
    )
    .subscribe({
      next: () => {
        this.notifSrv.dispatch('Operación exitosa', 'success')
        this.dialogRef.close()
      },
      error: (err) => {
        this.notifSrv.dispatch(err.error.message, 'error')
      } 
    });
  }

  private getFormData(): ChangePasswordRequest {
    const { newPassword, confirmPassword } =
      this.frm.getRawValue();

    return { newPassword, confirmPassword, userId: this.data.id}
  }
}
